import ibcChannelListOfSourceChainSelectorFamily from './ibcChannelListOfSourceChainSelectorFamily';
import ibcChannelListOfSelectorFamily from './selectorFamily';

export { ibcChannelListOfSourceChainSelectorFamily };

export default ibcChannelListOfSelectorFamily;
